import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1], delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);
